import { ReactNode } from "react";
import { EmojiCircle, Subtitle, Title, Wrapper } from "./auth-hero.styles";

export { AuthPage, AuthFormArea } from "./auth-hero.styles";

export type AuthHeroProps = {
  emoji: string;
  title: ReactNode;
  subtitle?: ReactNode;
};

const AuthHero = ({ emoji, title, subtitle }: AuthHeroProps) => (
  <Wrapper>
    <EmojiCircle aria-hidden>{emoji}</EmojiCircle>
    <Title>{title}</Title>
    {subtitle && <Subtitle>{subtitle}</Subtitle>}
  </Wrapper>
);

export default AuthHero;
